import { createFileRoute, redirect } from '@tanstack/react-router';

// The API and connector link to /billing; /billing/success stays its own page.
export const Route = createFileRoute('/billing')({
  beforeLoad: ({ location }) => {
    if (location.pathname.replace(/\/$/, '') !== '/billing') return;
    throw redirect({ href: `/account/billing${location.searchStr}${location.hash ? `#${location.hash}` : ''}` });
  },
});
